import React ,{useRef,useState,useEffect}from 'react'
import {TextField,Chip} from '@material-ui/core'
import ChipInput from 'material-ui-chip-input'
import { makeStyles } from '@material-ui/core/styles'
import FileGambar from '../../home/FileGambar'
import FileLink from '../../home/FileLink'
import FilePdf from '../../home/FilePdf'
import FileVideo from '../../home/FileVideo'
import Close from 'assets/icon/close-white.png'
import ImageUpload from 'assets/icon/imageUpload.png'
import VideoUpload from 'assets/icon/VideoUpload.png'
import DocumentUpload from 'assets/icon/DocumentUpload.png'
import { handleFile } from 'components/handleFile'
import { useDispatch,useSelector } from 'react-redux'
import { postDiskusi,putDiskusi } from 'redux/actions/forum'
import { CircularProgress } from '@material-ui/core'
import { modalToggleReset } from 'redux/actions/general'
import { setReducer } from 'redux/actions/reducer'
const useStyles = makeStyles(theme => ({
    textField: {
      [`& fieldset`]: {
        borderRadius: 10,
        fontWeight:'normal'
      },
      width:'100%',
      marginBottom:15
  },
  
}));
function chipRenderer({ text, handleDelete, isDisabled, className }, key) {

    const chipProps = {
        label: text,
        onDelete: handleDelete,
        disabled: isDisabled,
        className,
        key,
        size: 'small',
    }

    return <Chip {...chipProps} />
}
export default function Add_diskusi(props) {
    const inputFile = useRef(null) 
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    const reducer = useSelector(state => state.reducer)
    const general = useSelector(state => state.general)
    const classes=useStyles()
    const {post_diskusi}=reducer
    const [state, setstate] = useState({
        Id:0,
        ForumId:0,
        ParentId:0,
        Title:'',
        Text:'',
        Tags:[],
        Files:null,
        File_url:'',
        extension:''
    })
    useEffect(() => {
        if(props.modal_data.data){
            let {data}=props.modal_data
            let extension=get_url_extension(data.attachment)
            // console.log(`extension`, extension,linkify(data.text))
            let get_file_url=linkify(data.text)!==null?linkify(data.text)[0]:data.attachment
            setstate({
                ...state,
                Id:data.id,
                ForumId:data.forumId,
                ParentId:data.parentId,
                Title:data.title,
                Text:data.text,
                Tags:data.tags,
                File_url:get_file_url,
                extension:extension!==''?extension:'link'
            })
        }
        // console.log(`props.modal_data.data`, props.modal_data.data)
    }, [])
    const uploadImage=()=>{
        inputFile.current.click();
    }
    const uploadVideo=()=>{
        inputFile.current.click();
    }
    const uploadFile=()=>{
        inputFile.current.click();
    }
    const handleFiles=(e,type)=>{
        let handle= handleFile(e)
        if(handle.file_error===null){
            let file_url=URL.createObjectURL(handle.file)
            setstate({...state,Files:handle.file,File_url:file_url,extension:handle.extension})

        }
    }
    const renderPreviewFile=()=>{
        let {extension}=state
        if(extension==='jpg'||extension==='jpeg'||extension==='png'){
            return <FileGambar url={state.File_url}/>
        }
        if(extension==='pdf'){
            return <FilePdf url={state.File_url} preview={true}/>
        }
        if(extension==='mp4'){
            return <FileVideo url={state.File_url}/>
        }
        if(extension==='link'){
            return <FileLink url={state.File_url}/>
        }
    }
    function linkify(text) {
        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return text.match(urlRegex)
    }
    function get_url_extension( url ) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    const onChangeDesc=(e)=>{
        let {value}=e.target
        if(linkify(value)!==null){
            setstate({...state,Text:value,File_url:linkify(value)[0],extension:'link'})
        }else{
            setstate({...state,Text:value})
        }
    }
    const onChangeTags=(chip)=>{
        let c=`#${chip}`
        const regex = /[!"$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
        let removeSpace=c.replace(/\s/g, '');
        let removePunctuation=removeSpace.replace(regex,'');
        setstate({...state,Tags:[...state.Tags,removePunctuation]})
    }
    const deleteTags=(chip,index)=>{
        let filter=state.Tags.filter((data)=>{
            return data!==chip
        })
        setstate({...state,Tags:filter})

    }
    const onCreate=async ()=>{
        let fd= new FormData()
        fd.append('Id',state.Id)
        fd.append('ForumId',persist.forum_id)
        fd.append('ParentId',state.ParentId)
        fd.append('Title',state.Title)
        fd.append('Text',state.Text)
        fd.append('Tags',state.Tags)
        fd.append('Files',state.Files)
        let res
        if(props.modal_action==='edit_diskusi'){
            res=await dispatch(putDiskusi(fd))
        }else{
            res=await dispatch(postDiskusi(fd))
        }
        if(res){
            dispatch(modalToggleReset())
            props.modal_data.getAction()
            
        }
    }
    // console.log(`state`, state)
    return (
        <div>
            <TextField
                label="Judul"
                variant='outlined'
                value={state.Title}
                size='small'
                color='primary'
                name='name'
                // disabled={handleDisable()}
                className={classes.textField}
                onChange={(e)=>setstate({...state,Title:e.target.value})}
                multiline
            />
            <textarea onChange={(e)=>onChangeDesc(e)} value={state.Text}  autoFocus rows="7" className='font-nunito diskusi-field' placeholder="Deskripsi"></textarea>
            <br/><br/>
            {state.File_url!==''&&
            <div style={{position:'relative'}}>
                {renderPreviewFile()}
                <div className='cancel-btn'>
                    <img src={Close} style={{height:20}}  onClick={()=>setstate({...state,Files:null,File_url:''})}/>
                </div>
            </div>}
            <br/>
            <div className=' diskusi-footer'>
                <div className='tag-diskusi'>
                <ChipInput
                    classes={{
                        label: 'chip-input-label',
                        chip: 'chip',
                        inputRoot: 'chip-input-root',
                        input:'chip-input',
                        helperText:'helper-text'
                    }}
                    label="Tag"
                    variant='outlined'
                    margin='dense'
                    value={state.Tags}
                    onAdd={(chip)=>onChangeTags(chip)}
                    onDelete={(chip,index)=>deleteTags(chip,index)}
                    chipRenderer={chipRenderer}
                    className={classes.textField}
                />
                
                </div>
                &nbsp;
                <div className='div-flex div-justify-between'>
                <div className='file-diskusi div-flex'>
                    <div  onClick={uploadImage}>
                        <input  onChange={(e)=>handleFiles(e,'image')}  type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                        <img src={ImageUpload}/>
                    </div>
                    <div onClick={uploadVideo}>
                        <input onChange={(e)=>handleFiles(e,'video')} type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                        <img src={VideoUpload}/>
                    </div>
                    <div onClick={uploadFile}>
                        <input onChange={(e)=>handleFiles(e,'doc')} type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                        <img src={DocumentUpload}/>
                    </div>
                    
                </div>
                &nbsp;
                <button onClick={onCreate} className='btn-forum'>
                    
                    {general.isLoading?
                    <CircularProgress style={{color:'white'}}  size={20} />
                    :
                    props.modal_action==='edit_diskusi'?'Edit Diskusi':'Buat Diskusi'
                    }

                </button>
                </div>
            </div>
            <br/>
        </div>
    )
}
